import React from 'react';
import PropTypes from 'prop-types';
import TableReport from '@componentes/TableReport';
import Table from './Table';
import IntlMessage from '../../../../helpers/intlMessage';

function ImpressaoLaminasHistologia ({lista}) {
  return (
    <TableReport
      title={<IntlMessage id = "dashboards.taskControl.titleReportHistologySlides"/>}
      assinatura={<IntlMessage id = "dashboards.reports.subscriptionCRM"/>}
      children={lista}
    >
      {lista.map((item, i) => (
        <tr key={i} style={{border: 0}} className='relatorio-controle-laminas-histologia'>
          <td style={{border: 0, padding: 0}}>
            <Table item={item}/>
          </td>
        </tr>
      ))}
    </TableReport>
  );
}

ImpressaoLaminasHistologia.propTypes = {
  lista: PropTypes.array.isRequired
};

ImpressaoLaminasHistologia.defaultProps = {
  lista: []
};

export default ImpressaoLaminasHistologia;



// WEBPACK FOOTER //
// ./src/pages/controleTarefas/Histologia/Impressao/index.js